<div class="innerpage-fullwithbanner">
  <h2 class="bighead">{{pageHeading}}</h2>
  <ul class="bread-crumbs">
    <li><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li><a href="#" [routerLink]="['/users/employees']">Employees<span>|</span></a></li>
    <li>{{pageHeading}}</li>
  </ul>
</div>
<div class="section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="border-div margin0">
      <h2 class="mainhead "><span class="text">Profile</span></h2>
      <div class="leftsideprofile">
        <div class="profilepic">
          <img #profilePic src="{{userInputModel.ProfilePicPath}}">
          <file-upload (selectedFilesListEmitter)=selectedFilesListEmitter($event) (selectedFilePathEmitter)="selectedFilePathEmitter($event)" [uploadType]="fileUploadType" [clearFilescounter]="clearFiles"></file-upload>
          <a *ngIf="imageIdToDelete != null" href="javascript:void(0);" (click)="openModalForDelete(template,'deletemodal',imageIdToDelete,'the profile picture')" class="deletepic" triggers="hover" tooltip="Remove">
            <i class="icofont icofont-close icon"></i>
          </a>
        </div>
      </div>
      <div class="rightsideprofile">
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Role<span class="red">*</span></label>
              <label class="select">
                <select class="form-control" #role="ngModel" [disabled]="(IsExistingBroker || IsEditMode ) && isDisableRole" (change)="onRoleChange();" required [(ngModel)]="userInputModel.UserRoleId">
                  <option value="0">--Select--</option>
                  <option *ngFor="let userrole of userRoleList" [(ngValue)]="userrole.id">{{userrole.name}}</option>
                </select>
                <i [ngStyle]="{ 'display':IsExistingBroker ? 'none' : 'block' }"></i>
              </label>
              <p class="redtext" *ngIf="(roleValid) && userInputModel.UserRoleId ==0 && role.touched">Role is required</p>
              <p class="redtext" *ngIf="(!roleValid)">Role is required</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">First Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event)" #firstNameinput="ngModel" [(ngModel)]="userInputModel.FirstName" autocomplete="off" required type="text" maxlength="30">
              <p class="redtext" *ngIf="!showFNSpecCharVal && (firstNameValid && firstNameinput.invalid && firstNameinput.touched)">First name is required </p>
              <p class="redtext" *ngIf="!showFNSpecCharVal && (!firstNameValid)">First name is required </p>
              <p class="redtext" *ngIf="showFNSpecCharVal">{{specCharValMsg}}</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event)" #lastNameinput="ngModel" [(ngModel)]="userInputModel.LastName" autocomplete="off" required type="text" maxlength="30">
              <p class="redtext" *ngIf="!showLNSpecCharVal &&  (lastNameValid && lastNameinput.invalid && lastNameinput.touched)">Last name is required </p>
              <p class="redtext" *ngIf="!showLNSpecCharVal && (!lastNameValid)">Last name is required </p>
              <p class="redtext" *ngIf="showLNSpecCharVal">{{specCharValMsg}}</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email<span *ngIf="userInputModel.UserRoleId !== userRole.ComplianceBroker" class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event)" [disabled]="userInputModel.UserRoleId === userRole.ComplianceBroker" #emailinput="ngModel" (change)="validateemail()" autocomplete="off" [(ngModel)]="userInputModel.EmailAddress" required type="text" maxlength="100">
              <p class="redtext" *ngIf="(emailValid) && emailinput.invalid && emailinput.touched && userInputModel.UserRoleId !== userRole.ComplianceBroker">Email is required</p>
              <p class="redtext" *ngIf="(!emailValid) && emailvalidation =='' && userInputModel.UserRoleId !== userRole.ComplianceBroker">Email is required</p>
              <p class="redtext" *ngIf="(emailvalidation!='' && userInputModel.EmailAddress!='' && userInputModel.UserRoleId !== userRole.ComplianceBroker)">{{emailvalidation}}</p>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Password<span *ngIf="userInputModel.UserRoleId !== userRole.ComplianceBroker" class="red">*</span></label>
              <div *ngIf="!showUpdatePassword">
                <input type="password" class="form-control" (keydown)="onKeydown($event)" [disabled]="(userInputModel.UserRoleId === userRole.ComplianceBroker) || (IsEditMode && !enablePasswordInput)" name="" #passwordinput="ngModel" (change)="validatepassword()" [(ngModel)]="userInputModel.Password" required maxlength="250">
                <p class="redtext" *ngIf="(passwordValid && passwordinput.invalid && passwordinput.touched && passwordValidation =='') || (!passwordValid && passwordValidation =='') && userInputModel.UserRoleId !== userRole.ComplianceBroker">Password is required</p>
                <p class="redtext" *ngIf="(passwordValidation!='' && userInputModel.Password!='') && userInputModel.UserRoleId !== userRole.ComplianceBroker">{{passwordValidation}}</p>
              </div>
              <div class="d-flex flex-wrap gap-2" style="gap: 2px;" *ngIf="showUpdatePassword">
                <button class="btn btn-success user-add-update-pwd btn-lg flex-fill" (click)="openModalChangePassword(ChangePassword,'portfolioUpload userchangepasswordmodal')">
                  Update Password
                </button>

                <button class="btn btn-success user-add-update-pwd btn-lg flex-fill" (click)="sendResetPassword();">
                  Send Reset Password Link
                </button>
              </div>
              <!--<div *ngIf="showUpdatePassword">
                <button class="btn btn-success user-add-update-pwd  btn-lg" style="margin-right:5px;" (click)="openModalChangePassword(ChangePassword,'portfolioUpload userchangepasswordmodal')">Update Password</button>
                <button class="btn btn-success user-add-update-pwd  btn-lg" (click)="sendResetPassword();">Send Reset Password Link</button>
              </div>-->
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone<span class="red">*</span></label>
              <input class="form-control" #phoneNumberinput="ngModel" (keydown)="onKeydown($event)" required [(ngModel)]="userInputModel.PhoneNumber" mask='(000) 000-0000' type="text" maxlength="20">
              <p class="redtext" *ngIf="(phoneValid) && phoneNumberinput.invalid && phoneNumberinput.touched">Phone number is required</p>
              <p class="redtext" *ngIf="(!phoneValid)">Phone number is required</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Address Line 1</label>
              <input class="form-control" [(ngModel)]="userInputModel.Address1" (keydown)="onKeydown($event)" type="text" maxlength="75">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Address Line 2</label>
              <input class="form-control" [(ngModel)]="userInputModel.Address2" (keydown)="onKeydown($event)" type="text" maxlength="75">
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">State</label>
              <label class="select">
                <select class="form-control" [(ngModel)]="userInputModel.StateId" (change)="bindCity()">
                  <option value="0">--Select--</option>
                  <option *ngFor="let states of statesList" [(ngValue)]="states.Id">{{states.Name}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">City</label>
              <label class="select">
                <select class="form-control " [(ngModel)]="userInputModel.CityId">
                  <option value="0">--Select--</option>
                  <option *ngFor="let cities of citiesList" [(ngValue)]="cities.Id">{{cities.Name}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">ZIP</label>
              <input class="form-control" [(ngModel)]="userInputModel.Zip" (keydown)="onKeydown($event)" type="text" maxlength="5">
            </div>
          </div>

          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">User Status<span class="red">*</span></label>
              <label class="select">
                <!--[disabled]="IsAdd"-->
                <select class="form-control" #Status="ngModel" required [(ngModel)]="userInputModel.UserStatus">
                  <option value="0">--Select--</option>
                  <option *ngFor="let userstatus of lookupList" [(ngValue)]="userstatus.id">{{userstatus.description}}</option>
                </select>
                <i></i>
              </label>
              <p class="redtext" *ngIf="(userStatusValid) && userInputModel.UserStatus ==0 && Status.touched">User Status is required</p>
              <p class="redtext" *ngIf="(!userStatusValid)">User Status is required</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Company Name</label>
              <input class="form-control" (keydown)="onKeydown($event)" [disabled]="userInputModel.UserRoleId === userRole.ComplianceBroker" [(ngModel)]="userInputModel.CompanyName" type="text" maxlength="200" autocomplete="off">
            </div>
          </div>
          <div class="col-lg-6 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group" *ngIf="userInputModel.UserRoleId === userRole.Broker || userInputModel.UserRoleId === userRole.Admin|| userInputModel.UserRoleId === userRole.SuperAdmin">
              <label class="form-label">LinkedIn</label>
              <input class="form-control" placeholder="https://.." name='validate' #validate='ngModel' [(ngModel)]="userInputModel.UserLinkedInProfile" (keydown)="onKeydown($event)" pattern="^(https?:\/\/?(www|\w\w)\.?linkedin.com/)((in/[^/]+/?)|(pub/[^/]+/((\w|\d)+/?){3}))$" type="text" maxlength="500">
              <div style="color:red" *ngIf="!validate.valid">
                Invalid LinkedIn url
              </div>
              <div style="display:none!important" *ngIf="!validate.valid?linkedinurlvalid(false):linkedinurlvalid(true)">
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="clearfix"></div>
      <div class="margin-top-30" *ngIf="userInputModel.UserRoleId != userRole.DataEntryStaff">
        <div class="floatinghead floatinghead-xs clearfix">
          <h2 class="mainhead " *ngIf="userInputModel.UserRoleId == userRole.ComplianceBroker"><span class="text">Licence Details</span></h2>
          <h2 class="mainhead " *ngIf="userInputModel.UserRoleId != userRole.ComplianceBroker"><span class="text">Regional Licence Details</span></h2>
          <div class="uploadfile  btn  btn-circle btn-green " tooltip="Add Broker Regional Licenses" placement="left">

            <span class="fa fa-plus icon" aria-hidden="true" (click)="addFieldValue();"></span>
          </div>
        </div>
        <div class="table-responsive">

          <table class="table basictable">
            <thead>
              <tr>
                <th>#</th>
                <th>State</th>
                <th>License No.</th>
                <th>Expiration Date</th>
                <th>Default</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let field of brokerRegionalLicenses;let i = index">
                <td><p>{{i+1}}</p></td>
                <td>
                  <label class="select">
                    <select class="form-control" [(ngModel)]="field.StateId">
                      <option value="0">--Select--</option>
                      <option *ngFor="let states of statesList" [(ngValue)]="states.Id">{{states.Name}}</option>
                    </select>
                    <i></i>
                  </label>
                </td>
                <td>
                  <input class="form-control" [(ngModel)]="field.BrokerLicense" type="text" maxlength="50">
                </td>
                <td>
                  <div class="textbox-date">
                    <input placement="top" [(ngModel)]="field.ExpiryDate_Date" (keydown)="onKeydown($event)" placeholder="mm/dd/yyyy" class="form-control" bsDatepicker type="text" (ngModelChange)="validateExpirationDate()" [ngStyle]="{'margin-top': this.isExpiryDateValidate[i]===1 ? '19px' : '0px'}">
                    <i class="icofont icofont-ui-calendar icon"></i>
                  </div>
                  <div *ngIf="this.isExpiryDateValidate.length!=0">
                    <p class="redtext" *ngIf="this.isExpiryDateValidate[i]==1">
                      License expired
                    </p>
                  </div>
                </td>
                <td>
                  <label class="custom-checkbox withoutlabel">
                    <input type="checkbox" (change)="setDefault($event,i)" (keydown)="onKeydown($event)" [(ngModel)]="field.IsDefault" id="{{i}}">

                    <i></i>
                  </label>

                </td>
                <td>
                  <a href="javascript:void(0);" class="remove" tooltip="Remove" (click)="deleteFieldValue(i,field.Id)" placement="top"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                </td>
              </tr>

            </tbody>
            <tfoot>
              <tr *ngIf="brokerRegionalLicenses?.length == 0 ">
                <td colspan="9" class="odd no-data-available">
                  <div class="nodata">
                    <i class="fa fa-exclamation-triangle icon"></i>
                    <p>No Data Available</p>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="margin-top-30" *ngIf="userInputModel.UserRoleId === userRole.DataEntryStaff">
        <div class="floatinghead floatinghead-xs clearfix">
          <h2 class="mainhead "><span class="text">Designated Brokerage</span></h2>
          <!--<p class="redtext" *ngIf="(!brokerageValid)">Brokerage is required </p>-->
          <div class="uploadfile  btn  btn-circle btn-green " tooltip="Add Brokerage" placement="left">

            <span class="fa fa-plus icon" (click)="openModalBrokerage(BrokerageTemplate,'panlestyle')"></span>
          </div>
        </div>


        <div class="table-responsive">
          <table class="table basictable">
            <thead>
              <tr>

                <th>Brokerage Name</th>
                <th>Brokerage URL</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let field of result;let i = index">
                <td>
                  <p>{{field.BrokerageName}}</p>
                </td>
                <td>
                  <p><a href="{{_validationService.formatURL(field.WebsiteURL)}}" target="_blank">{{field.WebsiteURL}}</a></p>
                </td>
                <td>

                  <a href="javascript:void(0);" class="remove" tooltip="Remove" placement="top" (click)="deleteBrokerage(field.Id,i)">
                    <i aria-hidden="true" class="icofont icofont-close"></i>
                  </a>
                </td>
              </tr>

            </tbody>
            <tfoot>
              <tr *ngIf="result?.length == 0 ">
                <td colspan="9" class="odd no-data-available">
                  <div class="nodata">
                    <i class="fa fa-exclamation-triangle icon"></i>
                    <p>No Data Available</p>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <br />


      <div class="text-right">
        <button type="button" class="btn btn-default btn-lg" (click)="clearFeilds();">Cancel</button>
        <button class="btn btn-success  btn-lg" (click)="saveUser();">Save</button>
      </div>
    </div>
  </div>
</div>
<!--<ng2-toasty [position]="'top-right'"></ng2-toasty>-->
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Profile Picture</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to delete {{deleteTask}}?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="onRemoveImage(imageIdToDelete);modalRef.hide();">Delete</button>
    </div>
  </div>
</ng-template>


<ng-template #BrokerageTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Designated Brokerage</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="row">
      <div class="col-md-12">
        <label class="form-label">Brokerage</label>
        <div class="form-group smalldiv be-multiselect selected-div">
          <div class="select-dropdown multiselectdesign">
            <mat-form-field>
              <mat-select placeholder="Select Brokerage"
                          [(ngModel)]="userInputModel.BrokerageId"
                          multiple>
                @if (userInputModel.BrokerageId?.length > 1) {
                <mat-select-trigger>
                  <span>{{ userInputModel.BrokerageId?.length }} items selected</span>
                </mat-select-trigger>
                }
                @for (brokerage of inputBrokerage; track brokerage) {
                <mat-option [value]="brokerage.id" class="multi-dropdown-item">{{brokerage.name}}</mat-option>
                }
                @if (inputBrokerage.length === 0) {
                <mat-option class="matoptionnodata" disabled>
                  Nothing found...
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="saveBrokerageList!=null"><ul><li *ngFor="let item of saveBrokerageList">{{item}}</li></ul></div>
      </div>
      <div class="col-md-12 padding30">
        <div class="text-right">
          <button class="btn btn-lg btn-default" id="closeModal" (click)="modalRef.hide()">Cancel</button>
          <button class="btn btn-lg btn-success" [disabled]="disabledAddOrEditBtn" (click)="addOrEditBrokerage();">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #ChangePassword>
  <div class="offredetailspage section-margin">
    <div class="container">
      <div class="row">
        <button type="button" class="close pull-right file-pop-up-close margin-right-10" aria-label="Close" (click)="ClearModel();modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 update-password-maindiv">
          <h3 class="file-bluelabel margin-bottom-15">Update Password</h3>
          <br />
          <form autocomplete="off">
            <div class="row">
              <div class="col-md-12">
                <label class="form-label">New Password</label>
                <div class="form-group">
                  <input type="password" [ngModelOptions]="{standalone: true}" class="form-control" name="" #passwordinput="ngModel" (change)="validatechangepassword()" (keydown)="focusToConfirmPassword($event,'confirmInput')" [(ngModel)]="newUserPassword" required maxlength="250">
                  <p class="redtext" *ngIf="(passwordValid && passwordinput.invalid && passwordinput.touched && passwordValidation =='') || (!passwordValid && passwordValidation =='')">Password is required</p>
                  <p class="redtext" *ngIf="(passwordValidation!='' && newUserPassword!='')">{{passwordValidation}}</p>
                </div>
              </div>
              <div class="col-md-12">
                <label class="form-label">Confirm Password</label>
                <div class="form-group">
                  <input type="password" [ngModelOptions]="{standalone: true}" (keydown)="handleKeydown($event)" class="form-control" name="" id="confirmInput" #confirmpasswordinput="ngModel" (change)="checkConfirmPasswordValidity($event)" [(ngModel)]="confirmPassword" required maxlength="250">
                  <p class="redtext" *ngIf="(confirmPasswordValidation!='')">{{confirmPasswordValidation}}</p>
                </div>
              </div>
              <div class="col-md-12 padding30">
                <div class="text-right">
                  <button class="btn btn-lg btn-default" id="closeModal" (click)="ClearModel();modalRef.hide()" [class.disabled]="isDisabled">Cancel</button>
                  <button class="btn btn-lg btn-success" (click)="changePasswordonAdminClick();" [class.disabled]="isDisabled">Update</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-template>

